import { detect, track, isEnabled } from "@otto-ec/global-mpathy";

// Set data attribute on document root to give
// M-Pathy a hint what features to run.
detect(window.navigator.userAgent);

// Export m-pathy functionality to global namespace.
window.o_global = window.o_global || {};
window.o_global.mpathy = window.o_global.mpathy || { track, isEnabled };
